import React from 'react';

export default function SceneProgressIndicator({
  sceneIds,
  activeIndex,
  onSelect,
  getLabel,
  className = '',
}) {
  if (!sceneIds?.length) return null;

  return (
    <nav
      className={`scene-progress fixed right-3 top-1/2 z-50 hidden -translate-y-1/2 flex-col gap-2 md:flex lg:right-5 ${className}`}
      aria-label={getLabel('sections')}
    >
      {sceneIds.map((id, index) => {
        const isActive = index === activeIndex;

        return (
          <button
            key={id}
            type="button"
            onClick={() => onSelect(id)}
            className={`scene-progress__dot group relative flex items-center justify-end ${
              isActive ? 'scene-progress__dot--active' : ''
            }`}
            aria-label={getLabel(id)}
            aria-current={isActive ? 'true' : undefined}
          >
            <span className="scene-progress__tooltip pointer-events-none absolute right-5 whitespace-nowrap rounded-lg bg-secondary-900 px-2.5 py-1 text-xs font-medium text-white opacity-0 shadow-elegant transition-opacity duration-200 group-hover:opacity-100 group-focus-visible:opacity-100">
              {getLabel(id)}
            </span>
            <span className="scene-progress__marker" />
          </button>
        );
      })}
    </nav>
  );
}
